export const PREFERENCES_DEFAULTS = {
	editorMode: 'visual',
	isGeneralSidebarDismissed: false,
	panels: { 'post-status': true },
	features: {
		fixedToolbar: false,
	},
	pinnedPluginItems: {},
};
